import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";

// Main component function
const MessageForm = ({
  messageType,
  setMessageType,
  message,
  setMessage,
  msgName,
  setMsgName,
  intl
}) => {
  // State for the selected message type

  // --- STYLES ---
  // These styles are defined as objects to be applied inline.
  // This approach keeps the component self-contained.

  const formGroupStyle = {
    marginBottom: "25px",
    position: "relative",
    fontFamily: "Roboto",
  };

  const labelStyle = {
    position: "absolute",
    top: "-8px",
    left: "12px",
    fontSize: "12px",
    color: "#555",
    fontWeight: "500",
    backgroundColor: "white",
    padding: "0 4px",
    zIndex: 1,
  };

  const inputBaseStyle = {
    width: "100%",
    paddingTop: "12px",
    paddingBottom: "8px",
    paddingLeft: "12px",
    paddingRight: "12px",
    border: "1px solid #555",
    borderRadius: "4px",
    color: "#15205E",
    outline: "none",
    fontWeight: "bold",
    fontFamily: "Roboto",
    fontSize: "14px",
    boxSizing: "border-box",
    height: "45px",
  };

  const selectStyle = {
    ...inputBaseStyle,
    appearance: "none", // Removes default system appearance
    backgroundImage: `url('data:image/svg+xml;utf8,<svg fill="black" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>')`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 10px center",
    paddingRight: "40px",
    height: "45px",
  };

  const textareaStyle = {
    ...inputBaseStyle,
    minHeight: "200px",
    resize: "none",
    fontSize: "14px",
    fontWeight: "bold",
    paddingTop: "12px",
  };

  // --- JSX RENDER ---
  // The structure of the form is defined here.
  return (
    <div style={{ fontFamily: "Roboto" }}>
      <div>
        <div style={formGroupStyle}>
          <label htmlFor="messageName" style={labelStyle}>
            {injectIntlTranslation(intl, "Message Name", "Message Name")}
          </label>
          <input
            id="messageName"
            value={msgName}
            onChange={(e) => setMsgName(e.target.value)}
            style={inputBaseStyle}
          />
        </div>

        {/* Message Type Dropdown */}
        <div style={formGroupStyle}>
          <label htmlFor="messageType" style={labelStyle}>
            {injectIntlTranslation(intl, "Message Type", "Message Type")}
          </label>
          <select
            id="messageType"
            value={messageType}
            onChange={(e) => setMessageType(e.target.value)}
            style={selectStyle}
          >
            <option value="Warning">
              {" "}
              {injectIntlTranslation(intl, "Warning", "Warning")}
            </option>
            <option value="Error">
              {" "}
              {injectIntlTranslation(intl, "Error", "Error")}
            </option>
            {/* <option value="Success">
              {" "}
              {injectIntlTranslation(intl, "Success", "Success")}
            </option>
            <option value="Info">
              {" "}
              {injectIntlTranslation(intl, "Info", "Info")}
            </option> */}
          </select>
        </div>

        {/* Message Text Area */}
        <div style={formGroupStyle}>
          <label htmlFor="message" style={labelStyle}>
            {injectIntlTranslation(intl, "Message", "Message")}
          </label>
          <textarea
            id="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={textareaStyle}
          />
        </div>
      </div>
    </div>
  );
};

export default injectIntl(MessageForm);
